// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"738":"061d1152","966":"916831cb"}[chunkId] + ".chunk.js";
};